const PASSWORD_REGEX = new RegExp(process.env.KOOTH_PASSWORD_REGEX);

export default values => {
  const errors = {};

  if (!PASSWORD_REGEX.test(values.oldPassword)) {
    errors.oldPassword = __('validations.password');
  }

  if (!PASSWORD_REGEX.test(values.newPassword)) {
    errors.newPassword = __('validations.password');
  }

  if (values.newPasswordRepeat !== values.newPassword) {
    errors.newPasswordRepeat = __('validations.passwordMatch');
  }

  return errors;
};




/** WEBPACK FOOTER **
 ** ./src/members/Main/UserSettings/validate.js
 **/